export const  menuItems = [
    { path: "/about", label: "About Us" },
    { path: "/playground", label: "Playground" },
    { path: "/contact-us", label: "Contact Us" },
    { path: "/support", label: "FAQs" },
    { path: "/pricing", label: "Pricing" },
    { path: "/nkenneai-api", label: "NKENNEAi API" },

  ];